import { INews } from './INews';
import { NewsMapper } from './mapper';

/**
 * check the news result property and create a model with help of mapper class
 * @param   {array} data search api response
 */
export class NewsModel {
  newsData: Array<INews> = [];

  constructor(newsData: any = []) {
    if (newsData) {
      const transModel = new NewsMapper(newsData);
      this.newsData.push(transModel.newsItem);
    }
  }
}
